import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { useTranslation } from "../../contexts/translation-context.js";
import { classes } from "../../ui/file-upload/file-upload-wut.st.css";
import { FileUpload } from "../../ui/autocomplete/wut/FileUpload/FileUpload.js";
const FileInputWUT = ({
  onFocus,
  onBlur,
  disabled,
  buttonText,
  valueSliderLimit,
  required,
  inputId,
  ariaLabelledBy,
  ariaDescribedBy,
  files,
  hover,
  handleChange,
  accept,
  fileInputRef,
  fileUploadButtonRef,
  textBelowButtonRef,
  fieldId
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx("div", { className: classes.container, children: /* @__PURE__ */ jsx(
    FileUpload,
    {
      inputId,
      fileInputRef,
      fileUploadButtonRef,
      textBelowButtonRef,
      buttonText,
      accept,
      className: classNames(classes.root, classes.crop, {
        [classes.hover]: hover
      }),
      multiple: valueSliderLimit > 1,
      files,
      onChange: handleChange,
      onFocus,
      onBlur,
      disabled,
      ariaRoleDescription: t("file-upload.aria-roledescription"),
      ariaLabelledBy,
      ariaDescribedBy,
      required,
      fieldId
    }
  ) });
};
export {
  FileInputWUT
};
//# sourceMappingURL=file-input-wut.js.map
